/*
 * @providesModule LiveEventCompletedPLOW
 *
 */

export default function LiveEventCompletedPLOW() {
    return <></>;
}
